import src from "IMAGE";
export default { src, width: 264, height: 86, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAATUlEQVR42i3Muw2AMBADUN8PEDOwAi0NAgmxBxIrRCkzfBzpitecz4aZ/e7eVPUAEGmhmRwMv4iofHh5OOmhO+1gcHGliMiWzTXb01jrBH4EqJY9SPwAAAAASUVORK5CYII="};
